import "./submit-button.scss";
import template from "./submit-button.hbs";
import { SubmitButtonOptions } from "./types.js";
import { component } from "../../../hiyo/decorators.js";
import { Component } from "../../../hiyo/component.js";

@component(template)
export class SubmitButton extends Component<SubmitButtonOptions> {

    public lock(): void {
        super.lock();

        // Set locker attribute
        this.setAttribute("locked", "true");
    }

    public unlock(): void {
        super.unlock();

        // Remove locker attribute
        this.removeAttribute("locked");
    }

}